<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('stockIn.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('stockIn.pageTitle'),
          href: '/admin/stock-in'
        },
        {
          text: $t('create'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="ts-border ts-border-gray-300 ts-rounded-lg ts-p-3">
            <headerForm v-model="model" :validate="errors" />
          </div>
          <div class="ts-border ts-border-gray-300 ts-rounded-lg ts-p-3 ts-mt-4">
            <ProductDetail v-model="model" :validate="errors" />
          </div>
          <div class="row ts-mt-4">
            <div class="col-md-12 ts-space-x-4 ts-flex ts-justify-end">
              <ts-button @click.prevent="$router.push({ name: 'stock-in' })">{{
                $t('cancel')
              }}</ts-button>
              <ts-button color="primary" outline :waiting="waiting_new" @click.prevent="saveAddNew">{{ $t('savePrint')
              }}</ts-button>
              <ts-button color="primary" :waiting="waiting" @click.prevent="save">{{ $t('save') }}</ts-button>
            </div>
          </div>
        </ts-loading-banner>
        <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
          <ts-preview-pdf v-model="waiting_new" :src="src" />
        </a-modal>
        <!-- Purchase Type -->
        <a-modal :title="$t('purchaseOrder.createPurchaseType')" width="30%" v-model="add_new_purchase_type"
          :footer="null">
          <div class="row">
            <label class="form-col-label control-label col-md-12">{{
              $t('purchaseOrder.purchaseType')
            }}</label>
            <div class="col-md-12">
              <input v-model="purchase_type_model.purchase_type" type="text" class="form-control" />
            </div>
          </div>
          <div class="row ts-mt-4">
            <div class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end">
              <ts-button @click.prevent="() => (add_new_purchase_type = false)">
                {{ $t('cancel') }}
              </ts-button>
              <ts-button :waiting="waiting_new_purchase_type" @click.prevent="onSavePurchaseType" color="primary">{{
                $t('save') }}</ts-button>
            </div>
          </div>
        </a-modal>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import ProductDetail from './components/product-detail'
import headerForm from './components/header-form.vue'
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  name: 'stockInCreate',
  components: {
    ProductDetail,
    headerForm
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting_new: false,
      waiting: false,
      add_new_purchase_type: false,
      waiting_new_purchase_type: false,
      show_pdf: false,
      src: null,
      model: {
        stock_in_id: null,
        location_id: null,
        invoice_no: null,
        stock_in_date: moment().format('DD-MM-YYYY'),
        po_id: null,
        vendor_id: null,
        fix_rate: 4000,
        product_detail: [],
        remarks: null,
        purchase_type_id: null,
        credit_day: 0,
        next_payment_date: null,
        stock_in_warehouse_type: 'vendor'
      },
      purchase_type_model: {
        purchase_type: null
      }
    }
  },
  async created() {
    this.loading = true
    await this.fetchResource().finally(() => (this.loading = false))
    this.autoSelectMainWarehouse()
  },
  methods: {
    ...mapActions('stock/stockIn', ['fetchResource', 'store']),
    onSavePurchaseType() {
      this.waiting_new_purchase_type = true
      this.errors = new Errors()
      this.$store
        .dispatch('purchaseOrder/purchaseType/store', this.purchase_type_model)
        .then(async response => {
          this.$toasted.success(response.message)
          await this.$store.commit(
            'stock/stockIn/PUSH_NEW_PURCHASE_TYPE',
            response.data
          )
          this.model.purchase_type_id = response.data.purchase_type_id
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new_purchase_type = false
          this.add_new_purchase_type = false
        })
    },
    save() {
      this.waiting = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'stock-in' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    saveAddNew() {
      this.waiting_new = true
      this.show_pdf = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.src = response.url
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    autoSelectMainWarehouse() {
      this.model.location_id = this.$store.state.authUser.user.warehouses
        .filter(w => w.pivot.is_default == true)
        .reduce((i, v) => (i = v.location_id), null)
    },
    updateNextPaymentDate() {
      if (this.model.stock_in_date && this.model.credit_day > 0) {
        this.model.next_payment_date = moment(
          this.model.stock_in_date,
          'DD-MM-YYYY'
        )
          .add(this.model.credit_day, 'days')
          .format('DD-MM-YYYY')
      } else {
        this.model.next_payment_date = null
      }
    },
    clearInput() {
      this.model.stock_in_id = null
      this.model.location_id = null
      this.model.invoice_no = null
        ; (this.model.stock_in_date = moment().format('DD-MM-YYYY')),
          (this.model.po_id = null)
      this.model.vendor_id = null
      this.model.fix_rate = 4000
      this.model.remarks = null
      this.model.purchase_type_id = null
      this.model.credit_day = 0
      this.model.next_payment_date = null
      this.model.stock_in_warehouse_type = 'vendor'
      this.model.product_detail = [
        {
          product_id: null,
          uom_id: null,
          qty: 1,
          cost: 0,
          discount_rate: 0,
          discount_type: '%',
          total_after_discount: null,
          vat_rate: 0,
          vat_amount: 0,
          grand_total: 0,
          expiry_date: null,
          is_expire: false,
          require_imei: false,
          product_grade: '',
          imei_list: []
        }
      ]
      this.purchase_type_model.purchase_type = null
      this.errors = new Errors()
    }
  },
  watch: {
    'model.stock_in_date': function () {
      this.updateNextPaymentDate()
    },
    'model.credit_day': function () {
      this.updateNextPaymentDate()
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('stock/stockIn/CLEAR_SETUP')
    next()
  }
}
</script>
